document.addEventListener('DOMContentLoaded', function () {
  if (!window.LoadSwiper) return;

  window.LoadSwiper.then(function (module) {
    var Swiper = module.Swiper;
    var Navigation = module.Navigation;

    var sliders = document.querySelectorAll('[data-recommended-products-slider]');
    sliders.forEach(function (slider) {
      if (!slider.swiper) {
        var prevEl = document.querySelector('.swiper-prev');
        var nextEl = document.querySelector('.swiper-next');

        function updateNavState(swiper) {
          if (prevEl) {
            if (swiper.isBeginning) {
              prevEl.classList.add('swiper-nav--disabled');
            } else {
              prevEl.classList.remove('swiper-nav--disabled');
            }
          }
          if (nextEl) {
            if (swiper.isEnd) {
              nextEl.classList.add('swiper-nav--disabled');
            } else {
              nextEl.classList.remove('swiper-nav--disabled');
            }
          }
        }

        new Swiper(slider, {
          modules: [Navigation],
          slidesPerView: 'auto',
          spaceBetween: 16,
          grabCursor: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
          on: {
            init: function (swiper) {
              updateNavState(swiper);
            },
            slideChange: function (swiper) {
              updateNavState(swiper);
            },
            reachEnd: function (swiper) {
              if (nextEl) nextEl.classList.add('swiper-nav--disabled');
            },
            fromEdge: function (swiper) {
              updateNavState(swiper);
            },
          },
        });
      }
    });
  });
});
